/**
 * Blog posts merged into another post to stop them competing for the same search intent.
 * Old slug -> surviving post slug. Each gets a 301 (see src/redirects.ts).
 */
export const RETIRED_POSTS: Record<string, string> = {
  'ai-command-centers-logistics': 'fleet-visibility-control-tower-for-logistics-operations',
  'ai-agents-transform-last-mile-delivery': 'what-is-agentic-ai-logistics',
  'build-autonomous-delivery-operations': 'what-is-agentic-ai-logistics',
  'agent-based-vs-traditional-route-optimization': 'ai-route-optimization-delivery',
  'how-branded-tracking-pages-boost-customer-loyalty-and-retention': 'white-label-delivery-tracking-custom-tracking-url-and-terminology',
  'using-delivery-analytics-to-improve-roi-and-operational-efficiency': 'delivery-kpis-that-actually-matter-for-efficiency-and-growth',
};
